import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useTheme } from 'react-native-paper';
import QText from './QText';

const DrawerMenuItem = ({
  icon: IconComponent,
  title,
  onPress,
  isActive = false,
  badge = null,
  variant = 'default',
  ...iconProps
}) => {
  const theme = useTheme();
  const styles = createStyles(theme, isActive, variant);

  return (
    <TouchableOpacity
      style={styles.menuItem}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={styles.iconContainer}>
        <IconComponent
          width={20}
          height={20}
          color={
            variant === 'danger'
              ? theme.colors.redColor || '#EF4444'
              : isActive
                ? theme.colors.primary
                : theme.colors.secondaryText
          }
          {...iconProps}
        />
        {badge && (
          <View style={styles.badgeContainer}>
            <QText style={styles.badgeText}>{badge}</QText>
          </View>
        )}
      </View>
      <QText style={styles.menuText}>{title}</QText>
    </TouchableOpacity>
  );
};

const createStyles = (theme, isActive, variant) =>
  StyleSheet.create({
    menuItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 14,
      paddingHorizontal: 16,
      backgroundColor: isActive ? `${theme.colors.primary}08` : 'transparent',
      borderRadius: isActive ? 8 : 0,
      marginHorizontal: isActive ? 8 : 0,
    },
    iconContainer: {
      position: 'relative',
      marginRight: 12,
      width: 24,
      alignItems: 'center',
    },
    menuText: {
      fontSize: 14,
      fontWeight: isActive ? '600' : '400',
      color:
        variant === 'danger'
          ? theme.colors.redColor || '#EF4444'
          : isActive
            ? theme.colors.primary
            : theme.colors.secondaryText,
      flex: 1,
    },
    badgeContainer: {
      position: 'absolute',
      top: -6,
      right: -6,
      backgroundColor: theme.colors.redColor,
      borderRadius: 10,
      minWidth: 16,
      height: 16,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 4,
    },
    badgeText: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.colors.whiteTxt,
    },
  });

export default DrawerMenuItem;
